import React from 'react';
export function Bonuses() {
  const bonuses = [{
    icon: '🗓️',
    number: 'Bonus 1',
    subtitle: 'Planificador Semanal Docente',
    desc: 'Organizá toda tu semana de clases en una sola tarde. Plantillas A4 listas para imprimir o completar digital.',
    color: '#7B9E5A'
  }, {
    icon: '👥',
    number: 'Bonus 2',
    subtitle: 'Planillas de Seguimiento de Alumnos',
    desc: 'Ficha individual, registro de asistencia, tracker de competencias MCER y resumen anual de cada alumno.',
    color: '#C76F4A'
  }, {
    icon: '⚡',
    number: 'Bonus 3',
    subtitle: 'Cualquier Clase en Marcha en 10 Minutos',
    desc: '12 actividades de inicio, 10 exit tickets y 6 cierres de clase listos para usar. Sin preparación extra.',
    color: '#5A7BA8'
  }, {
    icon: '🧪',
    number: 'Bonus 4',
    subtitle: 'Nivelómetro de 15 Minutos',
    desc: 'Ubicá a cualquier alumno nuevo entre A1 y C2 antes de la segunda clase. + Banco de 50 feedbacks profesionales en italiano.',
    color: '#A85A8E'
  }, {
    icon: '💼',
    number: 'Bonus 5',
    subtitle: 'Italiano Corporativo',
    desc: '5 módulos para clientes de alto valor: Reuniones, Emails formales, Negociación, Entrevistas y Survival Italian in Brazil.',
    color: '#2E4E3A'
  }, {
    icon: '🍷',
    number: 'Bonus 6',
    subtitle: 'La Italia Fuera del Aula',
    desc: 'Playlists por nivel A1→C2, guía de cine italiano esencial, 10 curiosidades que cambian cómo enseñás y guía para organizar una Noche Italiana con tus alumnos.',
    color: '#8B3A3A'
  }];
  return <section className="py-16 md:py-24 bg-[#FAF7F2]" data-id="element-22">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-23">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16" data-id="element-24">
          <h2 className="font-sans font-black text-[#1A1A1A] tracking-[-0.02em] text-[34px] leading-[1.05] md:text-5xl lg:text-6xl mb-5 md:mb-6" data-id="element-25">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-base md:text-xl text-gray-500 mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-26">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-flex items-center justify-center px-6 md:px-8 py-3 md:py-4 bg-[#C76F4A] text-white rounded-full font-bold text-sm md:text-base uppercase tracking-wider shadow-lg shadow-[#C76F4A]/30" data-id="element-27">
            🎁 <span className="ml-2" data-id="element-28">GRATIS POR EL DÍA DE HOY</span>
          </div>
        </div>

        {/* Bonus Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-29">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-30">
              {/* Illustrated book mockup */}
              <div className="relative mb-8 mt-2" style={{
            perspective: '1000px'
          }} data-id="element-31">
                <div className="relative w-[180px] h-[230px] rounded-md shadow-2xl flex flex-col justify-between p-5 text-white" style={{
              backgroundColor: bonus.color,
              transform: 'rotate(-2deg)'
            }} data-id="element-32">
                  {/* Book spine */}
                  <div className="absolute left-0 top-0 bottom-0 w-3 rounded-l-md" style={{
                backgroundColor: bonus.color,
                filter: 'brightness(0.75)'
              }} data-id="element-33"></div>

                  {/* Icon top */}
                  <div className="text-2xl pl-2" data-id="element-34">{bonus.icon}</div>

                  {/* Center title */}
                  <div className="pl-2" data-id="element-35">
                    <p className="font-sans font-bold text-xl text-white" data-id="element-36">
                      {bonus.number}
                    </p>
                  </div>

                  {/* Bottom branding */}
                  <div className="pl-2 border-t border-white/20 pt-3" data-id="element-37">
                    <p className="text-[10px] font-bold tracking-[0.15em] text-white/80 uppercase" data-id="element-38">
                      ITALIANO 360™
                    </p>
                  </div>
                </div>
              </div>

              {/* GRATIS pill */}
              <div className="inline-flex items-center px-4 py-1.5 bg-green-50 border border-green-200 rounded-full mb-5" data-id="element-39">
                <span className="text-xs font-extrabold tracking-wider text-green-700 uppercase" data-id="element-40">
                  GRATIS
                </span>
              </div>

              {/* Title with icon */}
              <h3 className="font-sans font-black text-[#1A1A1A] tracking-[-0.01em] text-xl md:text-2xl mb-4 leading-tight" data-id="element-41">
                <span className="mr-2" data-id="element-42">{bonus.icon}</span>
                {bonus.number} — {bonus.subtitle}
              </h3>

              {/* Description */}
              <p className="text-gray-500 leading-relaxed text-base" data-id="element-43">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}